<template>
  <div style="height: calc(100vh - 196px);">
    <vxe-toolbar
      id="toolbarId_bc14"
      :custom="{ storage: true }"
      export
      :refresh="{ query: RefreshList }"
    >
      <template v-slot:buttons>
        <el-button @click="funcFilter">
          查询
        </el-button>
        <el-button v-if="!parentData.isDetail" @click="inviteTheDriver">
          邀请加入
        </el-button>
        <el-button @click="funcExport">
          导出
        </el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      ref="xTable"
      border
      resizable
      stripe
      highlight-current-row
      highlight-hover-row
      row-id="id"
      height="80%"
      :data="tableData"
      :loading="loading"
      :sort-config="{ remote: true }"
      export-config
      show-overflow
      align="center"
      @sort-change="sortList"
    >
      <vxe-table-column
        v-if="!parentData.isDetail"
        type="checkbox"
        width="60"
      />
      <vxe-table-column>
        <vxe-table-column
          field="name"
          title="实际承运人姓名"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.name"
            placeholder="请输入实际承运人姓名"
            clearable
          />
        </template>
      </vxe-table-column>
      <vxe-table-column>
        <vxe-table-column
          field="phone"
          title="手机号"
          min-width="130"
          sortable
        />
        <template v-slot:header>
          <el-input
            v-model="listQuery.phone"
            placeholder="请输入手机号"
            clearable
          />
        </template>
      </vxe-table-column>
    </vxe-table>
    <vxe-pager
      :loading="loading"
      :current-page.sync="listQuery.pageNum"
      :page-size.sync="listQuery.pageSize"
      :page-sizes="Pagingconf"
      :total="listQuery.total"
      :layouts="[
        'PrevJump',
        'PrevPage',
        'Number',
        'NextPage',
        'NextJump',
        'Sizes',
        'FullJump',
        'Total'
      ]"
      @page-change="handlePageChange"
    />
    <downloadData ref="downloadRef" />
  </div>
</template>
<script>
import { getInviteDriverList, inviteDriver } from "@/api/driver";
export default {
  name: "InviteTheDriver",
  props: {
    parentData: {
      type: Object,
      default() {
        return {
          isDetail: false
        };
      }
    }
  },
  data() {
    return {
      exportObj: {
        exportUrl: "/ntocc-basic-api/driver/exportInviteDriverList", //导出接口
        name: "邀请实际承运人"
      },
      loading: false,
      tableData: [],
      checkedRowArray: [],
      listQuery: {
        teamCode: "",
        name: "",
        phone: "",
        pageNum: 1,
        pageSize: 20,
        sortField: "",
        sortType: "",
        total: 0
      }
    };
  },
  created() {
    this.listQuery.teamCode = this.$route.query.partyCode || "";
    // this.findList();
  },
  methods: {
    findList() {
      this.loading = true;
      return new Promise(resolve => {
        getInviteDriverList(this.listQuery).then(response => {
          this.tableData = response.data.records;
          this.listQuery.total = response.data.total;
          this.loading = false;
          resolve();
        });
      });
    },
    // 邀请实际承运人
    inviteTheDriver() {
      // 获取所有选中的复选框
      this.checkedRowArray = this.$refs.xTable.getSelectRecords();
      if (!this.checkedRowArray || this.checkedRowArray.length === 0) {
        this.$message({ message: "请选择要邀请的实际承运人", type: "warning" });
      } else {
        const checkCodeArray = [];
        this.checkedRowArray.forEach(item => {
          checkCodeArray.push(item.partyCode);
        });
        const checkPartyCodes = checkCodeArray.join(",");
        inviteDriver({
          teamCode: this.listQuery.teamCode,
          driverCodes: checkPartyCodes
        }).then(response => {
          this.$message({ message: "邀请成功", type: "success" });
          this.findList();
        });
      }
    }
  }
};
</script>
